import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import {
  LC_CALENDAR_CURRENT,
  LC_CALENDAR_SELECT_CALENDARS,
  LC_CALENDAR_SETUP,
  LC_CALENDAR_SETUP_COMPLETE,
} from '../../common/constants/routingConstants'
import { RoleConfig } from '../../common/roleConfigs'

export const useSetupRoute = (config: RoleConfig | undefined) => {
  const { isBendProviderUsingCSForAvailability } = useFlags()

  if (config?.inProductCalendar?.simplifiedSetupFlow) {
    // Flag enabled: skip setup-complete, go directly to calendar live view
    if (isBendProviderUsingCSForAvailability) {
      return LC_CALENDAR_CURRENT.route
    }
    return LC_CALENDAR_SETUP_COMPLETE.route
  }
  return config?.inProductCalendar?.subCalendarSelection ? LC_CALENDAR_SELECT_CALENDARS.route : LC_CALENDAR_SETUP.route
}
